/* Elogio 2026 refresh */
(function () {
  // '55cm' -> '55 cm' on length buttons (label text only)
  Array.prototype.forEach.call(document.querySelectorAll('#product-description .swatch-element:not(.color) label'), function (l) { Array.prototype.forEach.call(l.childNodes, function (n) { if (n.nodeType === 3) n.nodeValue = n.nodeValue.replace(/(\d+)\s*cm/i, '$1 cm'); }); });
  // lets :active hover-states fire on touch devices
  document.addEventListener('touchstart', function () {}, { passive: true });
  var SW = { 'gold': '#C9A65E', 'silver': '#C8CBD0', 'matte black': '#262628', 'black': '#262628' };
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  // Finish swatches (hero)
  each(document.querySelectorAll('[data-e26-swatches]'), function (root) {
    var img = root.querySelector('[data-e26-img]');
    var label = root.querySelector('[data-e26-label]');
    var links = root.querySelectorAll('[data-e26-link]');
    each(root.querySelectorAll('.e26-swatch'), function (b) {
      b.addEventListener('click', function () {
        each(root.querySelectorAll('.e26-swatch'), function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        if (img && b.getAttribute('data-src')) { img.removeAttribute('srcset'); img.src = b.getAttribute('data-src'); }
        if (label) label.textContent = b.getAttribute('data-label');
        if (b.getAttribute('data-url')) each(links, function (l) { l.href = b.getAttribute('data-url'); });
      });
    });
  });

  // Product page (mobile): title + rating above the photos
  (function () {
    var photos = document.getElementById('product-photos');
    var desc = document.getElementById('product-description');
    if (!photos || !desc) return;
    var h1 = desc.querySelector('h1');
    var badge = desc.querySelector('.jdgm-preview-badge');
    var eyebrow = desc.querySelector('.e26-prod-eyebrow');
    if (!h1) return;
    var marker = document.createComment('e26-title-home');
    h1.parentNode.insertBefore(marker, h1);
    var holder = document.createElement('div');
    holder.className = 'e26-mtitle';
    photos.parentNode.insertBefore(holder, photos);
    var mq = window.matchMedia('(max-width: 989px)');
    function place() {
      if (mq.matches) { if (eyebrow) holder.appendChild(eyebrow); holder.appendChild(h1); if (badge) holder.appendChild(badge); holder.style.display = ''; }
      else { marker.parentNode.insertBefore(h1, marker.nextSibling); if (eyebrow) h1.parentNode.insertBefore(eyebrow, h1); if (badge) h1.parentNode.insertBefore(badge, h1.nextSibling); holder.style.display = 'none'; }
    }
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
    place();
  })();

  // Review carousel
  each(document.querySelectorAll('[data-e26-carousel]'), function (root) {
    var track = root.querySelector('[data-e26-track]');
    var prev = root.querySelector('[data-e26-prev]'), next = root.querySelector('[data-e26-next]');
    if (!track) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = track.scrollWidth - track.clientWidth;
      if ((e.deltaY < 0 && track.scrollLeft <= 0) || (e.deltaY > 0 && track.scrollLeft >= max - 1)) return;
      e.preventDefault(); track.scrollLeft += e.deltaY;
    }, { passive: false });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // Testimonials: filter creator photos by piece
  each(document.querySelectorAll('[data-e26-filter-root]'), function (root) {
    var items = root.querySelectorAll('[data-e26-item]'), wrap = root.querySelector('[data-e26-filter-chips]'), count = root.querySelector('[data-e26-filter-count]');
    var names = [], seen = {};
    each(items, function (it) { var n = it.getAttribute('data-e26-item'); if (n && !seen[n]) { seen[n] = 1; names.push(n); } });
    function apply(val) {
      var n = 0;
      each(items, function (it) { var show = !val || it.getAttribute('data-e26-item') === val; it.style.display = show ? '' : 'none'; if (show) n++; });
      each(wrap.children, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-val') === val ? 'true' : 'false'); });
      if (count) count.textContent = n + (n === 1 ? ' photo' : ' photos');
    }
    function chip(text, val) { var b = document.createElement('button'); b.type = 'button'; b.className = 'e26-chip'; b.setAttribute('data-val', val); b.textContent = text; b.addEventListener('click', function () { apply(val); }); wrap.appendChild(b); }
    if (names.length > 1) { chip('All', ''); names.forEach(function (n) { chip(n, n); }); }
    apply('');
  });

  // Review wall: show more
  each(document.querySelectorAll('[data-e26-wall]'), function (root) {
    var cards = root.querySelectorAll('.e26-review'), btn = root.querySelector('[data-e26-wall-more]'), count = root.querySelector('[data-e26-wall-count]');
    var per = parseInt(root.getAttribute('data-per'), 10) || 12, shown = per;
    function render() {
      each(cards, function (c, i) { if (i < shown) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); });
      var n = Math.min(shown, cards.length);
      if (count) count.textContent = 'Showing ' + n + ' of ' + cards.length;
      if (btn) btn.style.display = n >= cards.length ? 'none' : '';
    }
    if (btn) btn.addEventListener('click', function () { shown += per; render(); });
    render();
  });

  // Collection: clean card titles + finish filter
  var loop = document.getElementById('product-loop');
  if (!loop) return;
  var items = loop.querySelectorAll('.product-index');
  var colors = [], seen = {};
  each(items, function (it) {
    var h = it.querySelector('.product-info h3');
    if (!h || h.getAttribute('data-e26')) return;
    var parts = h.textContent.split(' - ').map(function (s) { return s.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    if (parts.length < 2) return;
    h.setAttribute('data-e26', '1');
    var col = parts[1];
    it.setAttribute('data-e26-color', col.toLowerCase());
    h.textContent = parts[0];
    var meta = document.createElement('span');
    meta.className = 'e26-card-meta';
    meta.textContent = col + (parts[2] ? ' · ' + parts[2] : '');
    h.parentNode.insertBefore(meta, h.nextSibling);
    if (!seen[col.toLowerCase()]) { seen[col.toLowerCase()] = 1; colors.push(col); }
  });
  if (colors.length < 2) return;
  var bar = document.createElement('div');
  bar.className = 'e26 e26-filterbar';
  var chips = document.createElement('div');
  chips.className = 'e26-filterbar__chips';
  chips.setAttribute('role', 'group');
  chips.setAttribute('aria-label', 'Filter by finish');
  var count = document.createElement('span');
  count.className = 'e26-count';
  count.setAttribute('aria-live', 'polite');
  function apply(val) {
    var n = 0;
    each(items, function (it) {
      var c = it.getAttribute('data-e26-color');
      var show = !val || !c || c === val;
      it.style.display = show ? '' : 'none';
      if (show) n++;
    });
    each(chips.children, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-val') === (val || '') ? 'true' : 'false'); });
    count.textContent = n + (n === 1 ? ' piece' : ' pieces');
  }
  function chip(text, val) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'e26-chip'; b.setAttribute('data-val', val);
    if (val) { var dot = document.createElement('i'); dot.style.background = SW[val] || '#888'; b.appendChild(dot); }
    b.appendChild(document.createTextNode(text));
    b.addEventListener('click', function () { apply(val); });
    chips.appendChild(b);
  }
  chip('All finishes', '');
  colors.forEach(function (c) { chip(c, c.toLowerCase()); });
  bar.appendChild(chips); bar.appendChild(count);
  loop.parentNode.insertBefore(bar, loop);
  apply('');
})();
